import pluralizer from 'pluralize';

export function pluralize(...args) {
  return pluralizer(...args);
}
